import makeActionCreator from 'src/lib/makeActionCreator';

export const OPEN_MENU = 'OPEN_MENU';
export const CLOSE_MENU = 'CLOSE_MENU';

export const openMenu = makeActionCreator(OPEN_MENU);
export const closeMenu = makeActionCreator(CLOSE_MENU);
